<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Feedback Point
        b-col(md="6")
          b-form-group(
            :label="$t('label.feedbackPoint')",
            :label-for="$t('label.feedbackPoint')",
            description=""
          )
            validation-provider(:name="$t('label.feedbackPoint')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="feedbackPoint",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}
        
        // Physical Location
        b-col(md="6")
          b-form-group(
            :label="$t('label.Physical_location')",
            :label-for="$t('label.Physical_location')",
            description=""
          )
            validation-provider(:name="$t('label.Physical_location')", rules="required", v-slot="{ errors }")
              v-select(
                v-model="data.physical_location",
                :reduce="(physical_locations) => physical_locations.value",
                label="title",
                :options="physical_locations",
                :placeholder="$t('placeholder.physical_location')"
              )
              small(class="text-danger") {{ errors[0] }}

        // Location
        b-col(md="6")
          b-form-group(
            :label="$t('label.Location')",
            :label-for="$t('label.Location')",
            description=""
          )
            validation-provider(:name="$t('label.Location')", rules="required", v-slot="{ errors }")
              v-select(
                v-model="data.location",
                :reduce="(locations) => locations.value",
                label="title",
                :options="filteredLocations",
                :placeholder="$t('placeholder.locations')"
              )
              small(class="text-danger") {{ errors[0] }}

      // Button
      b-row
        b-col(
          cols="12"
          class="text-right"
        )
          b-button(
            variant="primary",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}
</template>

<script>
// eslint-disable-next-line import/extensions
import { ref, toRefs, onMounted, computed, watch } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import useCommon from '@/views/organization/useCommon'
import vSelect from 'vue-select'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect
  },

  props: ['data', 'isSubmitting'],

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const form = ref(null)
    const { getLocationsForDropDown, locations, getPhysicalLocationsForDropDown, physical_locations } = useCommon()

    const validateFeedbackPoint = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success && props.data.location) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateFeedbackPoint()
      .then(() => emit('submit', toRefs(props.data)))
      .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    // Filtrar departamentos en base a la localidad seleccionada
    const filteredLocations = computed(() => {
      // Si no seleccionaron physical_locations → devolver todas
      if (!props.data.physical_location) return locations.value

      return locations.value.filter(loc =>
        props.data.physical_location === loc.physical_location
      )
    })

    watch(() => props.data.physical_location, () => {
      props.data.location = props.data.location && 
        filteredLocations.value.some(l => l.value === props.data.location)
        ? props.data.location
        : null
    })

    onMounted(() => {
      getPhysicalLocationsForDropDown()
      getLocationsForDropDown()
    })

    return {
      required,
      form,
      validateAndSubmit,
      physical_locations,
      filteredLocations,
    }
  },
}
</script>

<style scoped>

</style>
